/*
	Относительное время «скільки минуло» для черновиков.
	Без секунд: < 1 хв → «щойно», далі хвилини / години / дні.
*/

export const formatRelativeTime = (
	iso: string,
	now: number = Date.now(),
): string => {
	if (!iso) return "";
	const ts = new Date(iso).getTime();
	if (Number.isNaN(ts)) return "";

	const diffMs = Math.max(0, now - ts);
	const diffMinutes = Math.floor(diffMs / 60_000);

	if (diffMinutes < 1) return "щойно";
	if (diffMinutes < 60) return `${diffMinutes} хв тому`;

	const diffHours = Math.floor(diffMinutes / 60);
	if (diffHours < 24) return `${diffHours} год тому`;

	const diffDays = Math.floor(diffHours / 24);
	return `${diffDays} дн тому`;
};
